$(function () {
    if ($(".page--resource").length != 0) {
        var filter = function filter() {
            var documentType = $(".document-type-input:checked").val();
            var rangeID = $("#RangeFilterInput").val();
            $.getJSON({
                url: location.href + "ajaxRequest",
                data: {
                    "documentType": documentType,
                    "rangeID": rangeID
                }
            }).then(function (result) {
                if (documentType == 'logo') {
                    $('.range-filter-container').hide();
                } else {
                    $('.range-filter-container').show();
                }

                var label = $(".document-type-input:checked").next().html();
                var data = "";

                if (result.length == 0) {
                    data = '<div class="col-12">No result found</div>';
                } else {
                    for (var i = 0; i < result.length; i++) {
                        var row = result[i];
                        if(row.url){
                            let isNewHTML = row.isNew ? '<span class="is-new">New</span>' : '';
                            if (row.bg == 'image') {
                                data += `<div class="col-md-3 margin-bottom-20"><a class="document-link link" target="_blank" href="${row.url}"><div class="download-icon-container margin-top-20"><div class="icon-wrapper"><img src="${row.image_url}">${isNewHTML}</div></div><div class="margin-top-10">${row.title}</div></a></div>`;
                            } else {
                                var iconHtml = getIconHtml(row.file_type);
                                data += `<div class="col-md-3 margin-bottom-20"><a class="document-link link" target="_blank" href="${row.url}"><div class="download-icon-container margin-top-20"><div class="icon-wrapper">${iconHtml}${isNewHTML}</div></div><div class="margin-top-10">${row.title}</div></a></div>`;
                            }
                        }
                    }
                }
                var html = `<div class="col-12"> <h2 class="capitalize">${label}</h2></div>${data}`;
                $("#document-result").html(html);
            });
        };

        var getIconHtml = function getIconHtml(fileType) {
            fileType = fileType.toLowerCase();
            switch (fileType) {
                case 'pdf':
                    return '<span class="grand-icon icon-pdf"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'jpeg':
                    return '<span class="grand-icon icon-jpeg"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'mov':
                    return '<span class="grand-icon icon-mov"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'xlsx':
                    return '<span class="grand-icon icon-xlsx"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'docx':
                    return '<span class="grand-icon icon-docx"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'dwg':
                    return '<span class="grand-icon icon-dwg"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                case 'rfa':
                    return '<span class="grand-icon icon-rfa"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
                    break;

                default:
                    return '<span class="grand-icon icon-non-format"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span></span>';
            }
        };

        $(".document-type-input").change(filter);
        $("#RangeFilterInput").change(filter);
        filter();
    }
});